import { useAuthState } from "@/context";
import React, { useState } from "react";

export const useCurrency = () => {
  const { useCurrencies } = useAuthState();
  const { data } = useCurrencies();

  const [currencyType, setCurrencyType] = useState([]);

  React.useEffect(() => {
    setCurrencyType(data?.data?.data);
  }, [data?.data?.data]);

  const handleSelectCurrency = (currency) => {
    const res = currencyType?.find((item) => item?.code === currency);
    return res?.currency;
  };
  return { handleSelectCurrency };
};
